import React, { useEffect } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { backPage, LoguedArea } from "../../../Routes.js";
import SvgIcon from "@material-ui/core/SvgIcon";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

import { NavLink } from "react-router-dom";

import Slide from "@material-ui/core/Slide";

import { NOTICES } from "../../../data/notices";

const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: 500,
		flexGrow: 1,
		margin: "auto",
	},
}));

function Notices(props) {
	// Similar ao componentDidMount e componentDidUpdate:
	useEffect(() => {
		LoguedArea();
		backPage(props);
		document.getElementById("background").style.backgroundColor = "#2e2b84";
	}, []);

	const classes = useStyles();

	return (
		<Slide direction="left" in={true} mountOnEnter unmountOnExit>
			<div className={classes.root}>
				<Paper
					square
					elevation={0}
					className={classes.header}
				></Paper>
				<div className={"notices-hub"}>
					<h1 className={"orange-text"}>
						<NavLink to={"central-de-noticias"}>
							<SvgIcon component={ArrowBackIosIcon}>
								<path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
							</SvgIcon>
						</NavLink>
						Notícias
					</h1>
					<div className={"list-notices"}>
						{NOTICES.length > 0 ? (
							NOTICES.map((obj) => (
								<NavLink
									to={`noticia/${obj.idnoticia}`}
									key={`notice_${obj.idnoticia}`}
								>
									<div className={"list-notice"}>
										<h4>{obj.titulo}</h4>
										<p>
											{obj.prologo.substr(0, 150) + "…"}
										</p>
									</div>
								</NavLink>
							))
						) : (
							<label className="error-message">
								Não há notícias até o momento.
							</label>
						)}
					</div>
				</div>
			</div>
		</Slide>
	);
}

export default Notices;
